import Moment from "moment";
import _ from "lodash";
import mime from "mime-types";
export const filterList = (rawList, filters = {}) => {
    /* 1. Initialy load tasks list */
    let list = rawList;

    /* 2. Sort filtered tasks */
    if (filters.sorting.column) {
        switch (filters.sorting.column) {
            case "name": {
                if (filters.sorting.order === "asc") {
                    list = _.sortBy(list, function (item) {
                        return item.origin.toLowerCase();
                    });

                    break;
                } else {
                    list = _.sortBy(list, function (item) {
                        return item.origin.toLowerCase();
                    }).reverse();
                    break;
                }
            }
            case "uploadedBy": {
                if (filters.sorting.order === "asc") {
                    list = _.sortBy(list, ["user.firstName"]);
                    break;
                } else {
                    list = _.sortBy(list, ["user.firstName"]).reverse();
                    break;
                }
            }

            case "uploadDate": {
                if (filters.sorting.order === "asc") {
                    list = _.sortBy(list, function (item) {
                        return Moment(item["dateAdded"]).format("YYYY-MM-DD h:mm:ss")
                    });
                    break;
                } else {
                    list = _.sortBy(list, function (item) {
                        return Moment(item["dateAdded"]).format("YYYY-MM-DD h:mm:ss")
                    }).reverse();
                    break;
                }
            }

            case "workstreams": {
                if (filters.sorting.order === "asc") {
                    list = _.sortBy(list, function (item) {
                        return item.tagWorkstream.length > 0 ? item.tagWorkstream[0].label : "_1";
                    });
                    break;
                } else {
                    list = _.sortBy(list, function (item) {
                        return item.tagWorkstream.length > 0 ? item.tagWorkstream[0].label : "_1";
                    }).reverse();
                    break;
                }
            }

            case "accessList": {
                if (filters.sorting.order === "asc") {
                    list = _.sortBy(list, function (item) {
                        return item.accessList.length > 0 ? item.accessList[0].firstName : "_1";
                    });
                    break;
                } else {
                    list = _.sortBy(list, function (item) {
                        return item.accessList.length > 0 ? item.accessList[0].firstName : "_1";
                    }).reverse();
                    break;
                }
            }
        }
    }

    return list;
}

/**
 * Get parent of a folder up to root.
 * Array is reversed to return a top-down level list
 * 
 * @param {array}  folders 
 * @param {Object} folder 
 * @param {array}  parents 
 * @returns {array}
 */
export const getFolderParents = (folders, folder, parents = []) => {
    if (folder.folderId) {
        const parentFolder = folders.find(f => f.id === folder.folderId);

        return parentFolder
            ? getFolderParents(folders, parentFolder, [...parents, parentFolder])
            : parents.reverse();
    } else {
        return parents.reverse();
    }
}

export const getDocumentContentType = (documentName) => {
    const ct = mime.contentType(documentName);
    if (!ct)
        return "application/octet-stream";

    return ct;
}

export const downloadDocumentInBrowser = (name, origin) => {
    const encodedName = encodeURIComponent(name);
    const encodedOrigin = encodeURIComponent(origin);

    window.open(`/api/downloadDocument?fileName=${encodedName}&origin=${encodedOrigin}`);
}

export const getFileUrl = (projectId, documentId) => {
    return window.location.origin + `/account#/projects/${projectId}/files?action=copy&file-id=${documentId}`;
}

export function getFileEmbedUrl(fileName) {
    return `/api/file/upload/${fileName}`;
}

// Browser-viewable preview URL. The backend transcodes formats browsers can't
// render (e.g. TIFF) to PNG; other types are served unchanged.
export function getFilePreviewUrl(fileName) {
    return `/api/file-preview/upload/${fileName}`;
}

export const copyFileUrlToClipboard = (fileUrl) => {
    return navigator.clipboard.writeText(fileUrl);
}

// Action creators
export const openDeleteSingleFileModal = (file) => {
    return {
        type: "FILES_TOGGLE_DELETE_MODAL_DISPLAY_AND_SET_SELECTED",
        selected: file,
    }
}

export const formatFolders = (foldersToFormat) => {
    const folders = foldersToFormat.filter(f => f.type === "folder");
    let _roots = folders.filter(f => !f.folderId);
    let roots = {};
    let _subs = folders.filter(f => f.folderId);
    let subs = {};

    for (const root of _roots) {
        roots = { ...roots, [root.id]: root };
    }

    for (const sub of _subs) {
        subs = {
            ...subs,
            [sub.folderId]: {
                ...subs[sub.folderId] || {},
                [sub.id]: sub
            }
        }
    }

    return { roots, subs };
}